import { useState, useLayoutEffect } from "react";

const useStickFilterPosition = (popupRef, filterRef, isOpen) => {
  const [className, setClassName] = useState('filter-popup--stick-left');

  useLayoutEffect(() => {
    if (popupRef.current) {
      const isRtl = (document.dir === 'rtl');
      let newClassName =
        filterRef.current.getBoundingClientRect().x +
        popupRef.current.offsetWidth <
        window.innerWidth
          ? 'filter-popup--stick-left'
          : 'filter-popup--stick-right';
      if (popupRef.current.classList.contains('destination')) {
        newClassName = isRtl ? 'filter-popup--stick-right' : 'filter-popup--stick-left';
      }

      setClassName(newClassName);
    }
  }, [className, filterRef, isOpen, popupRef]);

  return className;
}

export default useStickFilterPosition;
